var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-b-70" }, [
    _vm.loading
      ? _c("div")
      : _c("div", [
          _c(
            "div",
            { staticClass: "shop" },
            [
              _c(
                "div",
                { staticClass: "banner" },
                [
                  _c(
                    "el-carousel",
                    {
                      attrs: { height: "100vw", "indicator-position": "none" },
                      on: { change: _vm.bannerSlide }
                    },
                    _vm._l(_vm.bannerList, function(item, index) {
                      return _c("el-carousel-item", { key: index }, [
                        _c("img", { attrs: { src: item, alt: "" } })
                      ])
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tips" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.bannerIndex) +
                          "/" +
                          _vm._s(_vm.bannerList.length)
                      )
                    ]),
                    _vm._v(" "),
                    _c("h3", [_vm._v(_vm._s(_vm.produInfo.content.info[0]))])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-name", attrs: { id: "form" } }, [
                _vm._v("添加收货信息")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "90px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人", prop: "real_name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入姓名" },
                        model: {
                          value: _vm.form.real_name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "real_name", $$v)
                          },
                          expression: "form.real_name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号" },
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", _vm._n($$v))
                          },
                          expression: "form.phone"
                        }
                      }),
                      _vm._v(" "),
                      _vm.showError
                        ? _c("div", { staticClass: "el-form-item__error" }, [
                            _vm._v(_vm._s(_vm.showText))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "验证码", prop: "verify_code" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "sms",
                          attrs: { placeholder: "请输入验证码" },
                          on: { input: _vm.handleSms },
                          model: {
                            value: _vm.form.verify_code,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "verify_code", $$v)
                            },
                            expression: "form.verify_code"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "suffix", disabled: _vm.timer },
                              on: { click: _vm.getCode },
                              slot: "suffix"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.timer
                                      ? _vm.count + "秒后重新获取"
                                      : "获取验证码"
                                  )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "address",
                      attrs: { label: "收货地址", prop: "address" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          placeholder:
                            "省份城市及详细街道、门牌号、小区、乡镇、村等"
                        },
                        model: {
                          value: _vm.form.address,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cbtn", on: { click: _vm.submitForm } },
                [_c("div", { staticClass: "text" }, [_vm._v("立即购买")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail" },
                _vm._l(_vm.imagesList, function(item, index) {
                  return _c("img", {
                    key: index,
                    staticClass: "lazy",
                    attrs: {
                      "data-src": item,
                      src: require("./../../assets/images/lazy.jpg"),
                      alt: ""
                    }
                  })
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.produInfo.content.info[1].slice(0, 4))),
              _c("b", [_vm._v(_vm._s(_vm.produInfo.price / 100))]),
              _vm._v("元")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text", on: { click: _vm.submitForm } }, [
              _c("div", { staticClass: "breathe" }, [_vm._v("立即抢购")])
            ])
          ])
        ]),
    _vm._v(" "),
    _vm.showWxRes
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "panel" }, [
            _c("h5", [_vm._v("恭喜您购买成功")]),
            _vm._v(" "),
            _c("div", { staticClass: "grey" }, [
              _c("h6", [_vm._v("收货信息：")]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("div", [_vm._v("订单编号:" + _vm._s(_vm.orderCode))]),
                _vm._v(" "),
                _c("div", [_vm._v("商品名称:" + _vm._s(_vm.produInfo.name))]),
                _vm._v(" "),
                _c("div", [_vm._v("收 货 人:" + _vm._s(_vm.form.real_name))]),
                _vm._v(" "),
                _c("div", [_vm._v("手 机 号:" + _vm._s(_vm.form.phone))]),
                _vm._v(" "),
                _c("div", [_vm._v("收货地址:" + _vm._s(_vm.form.address))])
              ])
            ]),
            _vm._v(" "),
            _c("div", [_vm._v("温馨提示：如需要变更收货信息请联系沐风老师")])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.actOver !== ""
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "panel" }, [
            _c("div", { staticClass: "over" }, [_vm._v(_vm._s(_vm.actOver))])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05048cda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05048cda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/index.vue
// module id = DFNG
// module chunks = 1